import { render, staticRenderFns } from "./CartTotalsPartial.vue?vue&type=template&id=1f345c3a&scoped=true&"
import script from "./CartTotalsPartial.vue?vue&type=script&lang=js&"
export * from "./CartTotalsPartial.vue?vue&type=script&lang=js&"
import style0 from "./CartTotalsPartial.vue?vue&type=style&index=0&id=1f345c3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f345c3a",
  null
  
)

export default component.exports